import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {select, Store} from '@ngrx/store';

import {GroupService} from '../../../core';
import * as fromRoot from '../../../reducers';
import {Observable} from 'rxjs';
import {OrganizationWithToken} from '../../../core/models/core';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'awair-group-new-dialog',
  templateUrl: './group-new-dialog.component.html',
  styleUrls: ['./group-new-dialog.component.scss']
})

export class GroupNewDialogComponent implements OnInit {

  selectedOrganization$: Observable<OrganizationWithToken> = this.rootStore.pipe(
    select(fromRoot.selectedOrganization),
    filter((selectedOrganization: OrganizationWithToken) => selectedOrganization != null)
  );

  groupName: string = '';
  errMsg: string = '';
  isError: boolean = false;
  isLoading: boolean = false;

  constructor(private rootStore: Store<fromRoot.State>,
              private groupService: GroupService,
              private myDialogRef: MatDialogRef<GroupNewDialogComponent>) {
  }

  ngOnInit() {
  }

  onChangeName(input: string): void {
    this.groupName = input;

    if (input.length > 0) {
      this.isError = false;
    }
  }

  onCreate(organizationToken: string): void {
    if (!(this.isLoading || this.isError || this.groupName.length === 0)) {
      this.isLoading = true;

      this.groupService.createGroup(organizationToken, this.groupName).subscribe(
        (response: { message: string }) => {
          this.isLoading = false;

          // Temporarily send the group name
          this.myDialogRef.close(this.groupName);
          // When API is ready, return the created group object
          // this.myDialogRef.close(response);
        },
        (error: Response) => {
          this.isLoading = false;

          if (error.status === 422) {
            this.errMsg = 'Group name already exists';
          } else if (error.status === 0) {
            this.errMsg = 'No response from the server. Please try again later';
          } else {
            this.errMsg = 'Server error. Please try again later';
          }

          this.isError = true;

          setTimeout(() => {
            this.isError = false;
          }, 3000);
        }
      );
    }
  }

  onCancel(): void {
    if (this.groupName.length > 0) {
      if (confirm('Changes will not be saved.\nAre you sure you want to exit?')) {
        this.myDialogRef.close();
      }
    } else {
      this.myDialogRef.close();
    }
  }
}
